// Defaults
const defaultOptions = {
  quality: 0.8,
  width: undefined,
  height: undefined,
  Canvas: undefined,
  crossOrigin: 'anonymous',
  drawType: 'line',
};

// Return Promise
const canvasMerge = function (mainImage, sources, options) {
  if (mainImage === void 0) return;
  if (sources === void 0) sources = [];
  if (options === void 0) options = {};
  return new Promise(function (resolve) {
    options = Object.assign({}, defaultOptions, options);

    // Load image
    const imagePromise = (mainImage) => {
      return new Promise(function (resolve) {
        // Convert sources to objects
        if (mainImage.constructor.name !== 'Object') {
          mainImage = {src: mainImage};
        }
        // Resolve source and img when loaded
        const img = new Image();
        img.crossOrigin = options.crossOrigin;
        // img.onerror = function () { return reject(new Error('Couldn\'t load image')); };
        img.onload = function () {
          return resolve(Object.assign({}, {img: img}));
        };

        img.src = mainImage.src;
      });
    };

    // Get canvas context

    // When sources have loaded
    resolve(
      imagePromise(mainImage).then((image) => {
        const canvas = options.Canvas ? new options.Canvas() : window.document.createElement('canvas');
        // Set canvas dimensions
        canvas.width = options['width'] || image.img['width'];
        canvas.height = options['height'] || image.img['height'];
        const ctx = canvas.getContext('2d');

        //Draw main image
        ctx.drawImage(image.img, 0, 0);
        // Draw sources to canvas
        if (options.drawType == 'line') {
          sources.forEach(function (image) {
            ctx.globalAlpha = image.opacity ? image.opacity : 1;
            ctx.beginPath(); // Start a new path
            ctx.moveTo(image.mx, image.my); // Move the pen to (30, 50)
            ctx.lineTo(image.x, image.y); // Draw a line to (150, 100)
            ctx.lineWidth = 5;
            ctx.strokeStyle = '#9cc1e5';
            return ctx.stroke();
          });
        } else if (options.drawType == 'rect') {
          ctx.globalAlpha = sources.opacity ? sources.opacity : 1;
          ctx.beginPath();
          ctx.rect(sources.x, sources.y, sources.width, sources.height);
          ctx.lineWidth = 5;
          ctx.strokeStyle = '#9cc1e5';
          ctx.stroke();
        } else if (options.drawType == 'circle') {
          sources.forEach(function (image) {
            ctx.globalAlpha = image.opacity ? image.opacity : 1;
            ctx.beginPath();
            ctx.arc(image.x, image.y, image.radius, 0, 2 * Math.PI);
            ctx.fillStyle = image.color;
            ctx.fill();
          });
        } else if (options.drawType == 'emptyCircle') {
          sources.forEach(function (image) {
            ctx.globalAlpha = image.opacity ? image.opacity : 1;
            ctx.beginPath();
            ctx.arc(image.x, image.y, image.radius, 0, 2 * Math.PI);
            ctx.strokeStyle = image.color;
            ctx.lineWidth = 10;
            ctx.stroke();
          });
        }

        if (options.Canvas && options.format === 'image/jpeg') {
          // Resolve data URI for node-canvas jpeg async
          return new Promise(function (resolve, reject) {
            canvas.toDataURL(
              options.format,
              {
                quality: options.quality,
                progressive: false,
              },
              function (err, jpeg) {
                if (err) {
                  reject(err);
                  return;
                }
                resolve(jpeg);
              }
            );
          });
        }

        // Resolve all other data URIs sync
        //
        // document.body.append(canvas);
        return canvas.toDataURL(options.format, options.quality);
      })
    );
  });
};

export default canvasMerge;
//# sourceMappingURL=index.es2015.js.map
